import useEmbeddedMessaging from "./useEmbeddedMessaging";
import chatIcon from "./emb_chat_icon.png";
import "./AgentForcePanel.scss";

export default function AgentForcePanel() {
    const { loading, error, launchChat } = useEmbeddedMessaging();
    const label = error || (loading ? "Loading chat" : "Open chat");
    const classes = [
        "agentforce-launcher",
        loading && !error && "agentforce-launcher--loading",
        error && "agentforce-launcher--error",
    ].filter(Boolean).join(" ");

    return (
        <button
            type="button"
            className={classes}
            aria-label={label}
            aria-busy={loading && !error}
            title={label}
            onClick={launchChat}
            disabled={loading || !!error}
        >
            <img className="agentforce-launcher__icon" src={chatIcon} alt="" />
            {loading && !error && <span className="agentforce-launcher__spinner" />}
        </button>
    );
}
